import { useState, useEffect } from 'react'

import _ from 'lodash'

import {
  Modal,
  Input,
  Markdown,
  LegacyPage,
  Stack,
  Select,
} from 'peach/components'
import { useQueryParams } from 'peach/router'

const text = `
# Gettysburg Address

> Four score and seven years ago our fathers brought forth on this continent, a new nation, conceived in Liberty, and dedicated to the proposition that all men are created equal.

> Now we are engaged in a great civil war, testing whether that nation, or any nation so conceived and dedicated, can long endure. We are met on a great battle-field of that war. We have come to dedicate a portion of that field, as a final resting place for those who here gave their lives that that nation might live. It is altogether fitting and proper that we should do this.

> But, in a larger sense, we can not dedicate — we can not consecrate — we can not hallow — this ground. The brave men, living and dead, who struggled here, have consecrated it, far above our poor power to add or detract. The world will little note, nor long remember what we say here, but it can never forget what they did here. It is for us the living, rather, to be dedicated here to the unfinished work which they who fought here have thus far so nobly advanced. It is rather for us to be here dedicated to the great task remaining before us — that from these honored dead we take increased devotion to that cause for which they gave the last full measure of devotion — that we here highly resolve that these dead shall not have died in vain — that this nation, under God, shall have a new birth of freedom — and that government of the people, by the people, for the people, shall not perish from the earth.

Delivered by President Abraham Lincoln at the dedication of the Soldier’s National Cemetery at the scene of the Battle of Gettysburg of the American Civil War on November 19, 1863.

`
const options = [
  'one...',
  { value: 'two' },
  'three',
  'four',
  'FiveFiveFiveFiveFiveFiveFiveFiveFiveFiveFive',
  { label: 'Six', value: 6 },
  7,
  'Eight',
  'null',
  null,
  { label: 'Null Value', value: null },
  { label: 'False Value', value: false },
  { label: 'True Value', value: true },
]
const Scratch = () => {
  const [value, onChange] = useState([])

  const [singleValue, onChangeSingleValue] = useState()

  const [{ foo, bar }, { updateParams }] = useQueryParams()
  const [fooStr, setFooStr] = useState(foo)
  const [barStr, setBarStr] = useState(bar)

  useEffect(() => {
    updateParams({ foo: fooStr, bar: barStr })
  }, [updateParams, fooStr, barStr])

  return (
    <LegacyPage>
      <Stack>
        <Select
          label='Single Numbers'
          nullable
          onChange={onChangeSingleValue}
          options={options}
          value={singleValue}
        />

        <Select
          label='Multiple Numbers'
          multi
          onChange={onChange}
          options={options}
          value={value}
        />
        <Select
          label='Searchable'
          multi
          onChange={onChange}
          options={options}
          searchable
          value={value}
        />

        <Modal
          onSubmit={() => new Promise((res) => _.delay(() => res(1), 2000))}
          title='Big Contents'
          trigger
        >
          <Markdown markdown={text} />
        </Modal>
        <Modal
          onSubmit={() => new Promise((res) => _.delay(() => res(1), 2000))}
          title='Query Params'
          trigger
        >
          <Input label='Foo' onChange={setFooStr} value={fooStr} />
          <Input label='Bar' onChange={setBarStr} value={barStr} />
          <Markdown markdown='# Hello' />
        </Modal>
      </Stack>
    </LegacyPage>
  )
}

export default Scratch
